import { createContext } from "react";

type Value = {
  showPrompt: boolean;
  installer: Installer | null;
};

export const PWAInstallationContext = createContext<Value>({
  showPrompt: false,
  installer: null,
});

type Installer = {
  prompt: () => void;
};
